import Konva from "konva";
import { Group, Path, Rect } from "react-konva";
import { FileColumn, IMondayTaskController } from "../../controller";
import tracking from "frontend/tracking";

const SIZE = 24;
const SHOW_ICON_WIDTH = 13;
const HIDE_ICON_WIDTH = 15;
const HIDE_ICON_HEIGHT = 11;

interface VisibilityButtonProps extends Konva.NodeConfig {
  controller: IMondayTaskController;
  file: FileColumn["value"][0] & { hidden: boolean };
}

export function VisibilityButton(props: VisibilityButtonProps) {
  const { controller, file, ...restProps } = props;

  const showIcon = (
    <Group x={SIZE / 2 - SHOW_ICON_WIDTH / 2} y={SIZE / 2}>
      <Path
        data="M5.77248 5.77216C5.72374 6.04397 5.46389 6.2248 5.19208 6.17606C4.92027 6.12732 4.73944 5.86747 4.78818 5.59566L5.05465 4.1096C5.10339 3.83779 5.36324 3.65696 5.63505 3.7057C5.90685 3.75444 6.08769 4.01429 6.03895 4.2861L5.77248 5.77216Z"
        fill="#7F869B"
      />
      <Path data="M5.54672 4.19783L5.28024 5.68398" stroke="#7F869B" strokeWidth={1} lineCap="round" />
      <Path
        data="M8.19639 5.71137C8.24513 5.98318 8.50498 6.16401 8.77679 6.11527C9.0486 6.06653 9.22943 5.80668 9.18069 5.53487L8.91422 4.04881C8.86549 3.777 8.60563 3.59617 8.33383 3.64491C8.06202 3.69364 7.88118 3.9535 7.92992 4.2253L8.19639 5.71137Z"
        fill="#7F869B"
      />
      <Path
        data="M2.2913 4.59874C2.14859 4.83515 1.84125 4.9111 1.60485 4.76839C1.36844 4.62568 1.29249 4.31834 1.4352 4.08194L2.21545 2.78942C2.35816 2.55302 2.6655 2.47706 2.9019 2.61977C3.13831 2.76248 3.21427 3.06982 3.07155 3.30623L2.2913 4.59874Z"
        fill="#7F869B"
      />
      <Path
        data="M11.8471 4.4547C11.9898 4.69111 12.2972 4.76706 12.5336 4.62435C12.77 4.48164 12.8459 4.1743 12.7032 3.9379L11.923 2.64538C11.7803 2.40897 11.4729 2.33302 11.2365 2.47573C11.0001 2.61844 10.9242 2.92578 11.0669 3.16218L11.8471 4.4547Z"
        fill="#7F869B"
      />
      <Path
        data="M12.5722 0.740143C12.7156 0.504136 13.0237 0.428842 13.2597 0.572175C13.4957 0.715524 13.571 1.02366 13.4277 1.25967C12.2279 3.23496 9.77627 4.54385 6.99997 4.54385C4.22367 4.54385 1.77201 3.23496 0.572236 1.25967C0.428903 1.02366 0.504197 0.715524 0.740204 0.572175C0.976218 0.428842 1.28435 0.504136 1.4277 0.740143C2.41933 2.37271 4.51808 3.54385 6.99997 3.54385C9.48186 3.54385 11.5806 2.37271 12.5722 0.740143Z"
        fill="#7F869B"
      />
    </Group>
  );

  const hideIcon = (
    <Group x={SIZE / 2 - HIDE_ICON_WIDTH / 2} y={SIZE / 2 - HIDE_ICON_HEIGHT / 2}>
      <Path
        data="M14.5 5.5C12.7 8.5 10.45 10 7.75 10C5.05 10 2.8 8.5 1 5.5C2.8 2.5 5.05 1 7.75 1C10.45 1 12.7 2.5 14.5 5.5Z"
        stroke="#7F869B"
        strokeWidth={1}
        lineCap="round"
        lineJoin="round"
      />
      <Path
        data="M6.25 5.5C6.25 5.89782 6.40804 6.27936 6.68934 6.56066C6.97064 6.84196 7.35218 7 7.75 7C8.14782 7 8.52936 6.84196 8.81066 6.56066C9.09196 6.27936 9.25 5.89782 9.25 5.5C9.25 5.10218 9.09196 4.72064 8.81066 4.43934C8.52936 4.15804 8.14782 4 7.75 4C7.35218 4 6.97064 4.15804 6.68934 4.43934C6.40804 4.72064 6.25 5.10218 6.25 5.5Z"
        stroke="#7F869B"
        strokeWidth={1}
        lineCap="round"
        lineJoin="round"
      />
    </Group>
  );

  return (
    <Group
      {...restProps}
      width={SIZE}
      height={SIZE}
      onMouseEnter={(e) => {
        const container = e.target.getStage()?.container();
        if (container) container.style.cursor = "pointer";
      }}
      onMouseLeave={(e) => {
        const container = e.target.getStage()?.container();
        if (container) container.style.cursor = "inherit";
      }}
      onClick={(e) => {
        e.evt.stopPropagation();
        e.evt.preventDefault();
        tracking.trackAnalyticsEvent("monday_task_file_visibility_changed", {
          action: file.hidden ? "showing" : "hiding",
        });
        controller.toggleFileVisibility(file.id);
      }}
    >
      <Rect cornerRadius={6} width={SIZE} height={SIZE} opacity={0.3} fill={"transparent"} listening />
      {file.hidden ? showIcon : hideIcon}
    </Group>
  );
}
